module.exports = __webpack_public_path__ + "img/wood-footer.79c5309e.svg";